var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-100"},[[_c('v-row',{staticClass:"h-100"},[_c('v-col',{staticClass:"section-list-tills pr-0",attrs:{"cols":"3"}},[_c('tills-list')],1),_c('v-col',{staticClass:"section-till-movements",attrs:{"cols":"9"}},[_c('div',[(_vm.selected_till && _vm.selected_till.status == 'abierta')?_c('till-detail'):_vm._e(),(
              _vm.selected_till &&
                _vm.selected_till.status == 'cerrada' &&
                this.$hasPermision('movimientos.open')
            )?_c('closed-till'):_vm._e()],1)])],1)]],2)}
var staticRenderFns = []

export { render, staticRenderFns }